"use client";

import { useState, type ReactNode, type KeyboardEvent } from "react";

interface ExpressShippingTooltipProps {
	trigger: ReactNode;
	children: ReactNode;
	ariaLabel: string;
}

export function ExpressShippingTooltip({ trigger, children, ariaLabel }: ExpressShippingTooltipProps) {
	const [open, setOpen] = useState(false);

	const handleKey = (e: KeyboardEvent) => {
		if (e.key === "Escape") setOpen(false);
	};

	return (
		<span className="relative inline-block">
			<button
				type="button"
				aria-label={ariaLabel}
				aria-expanded={open}
				tabIndex={0}
				onMouseEnter={() => setOpen(true)}
				onMouseLeave={() => setOpen(false)}
				onFocus={() => setOpen(true)}
				onBlur={() => setOpen(false)}
				onKeyDown={handleKey}
				className="font-inherit inline-block cursor-help border-0 bg-transparent p-0 text-left"
			>
				{trigger}
			</button>
			{open && (
				<span
					role="tooltip"
					className="absolute left-0 top-[calc(100%+8px)] z-30 w-[290px] rounded-xl border border-border bg-popover p-3.5 text-xs leading-relaxed text-popover-foreground shadow-lg duration-200 animate-in fade-in slide-in-from-top-1"
				>
					{children}
				</span>
			)}
		</span>
	);
}
